import React, { Component } from 'react'
import { dispatcher } from './NavigationDispatcher'
import Constants from 'scripts/base/Constants'
import PropTypes from 'prop-types'
import { customEvent } from 'scripts/helpers/AppHelper'
const subnavigation = SubNavigationView =>
  class SubNavigation extends Component {
    constructor(props) {
      super(props)

      this.toggleWithId = this.toggleWithId.bind(this)
      this.update = this.update.bind(this)
      this.active = false
      this.setActiveNav = this.setActiveNav.bind(this)
      this.eventData = { id: this.props.dropdown, contextual: this.props.contextual }
    }

    update(data) {
      if (data.id === this.props.dropdown) {
        this.active = !this.active
        this.setActiveNav(this.active)
        dispatcher.emit(Constants.Navigations.TOGGLE_NAV_CLASS, {
          id: this.props.dropdown,
          contextual: this.props.contextual,
          active: this.active
        })
      } else if (data.id !== this.props.dropdown && this.active) {
        if (this.props.dropdown !== data.contextual) {
          this.active = false
          dispatcher.emit(Constants.Navigations.TOGGLE_NAV_CLASS, {
            id: this.props.dropdown,
            contextual: this.props.contextual,
            active: this.active
          })
        }
      }
    }

    setActiveNav(active) {
      const id = (active) ? this.props.dropdown : null
      dispatcher.emit(Constants.Navigations.STORE_ACTIVE_NAV, { id: id, contextual: this.props.contextual })
    }

    componentDidMount() {
      dispatcher.on(Constants.Navigations.TOGGLE_NAV, this.update)
    }

    componentWillUnmount() {
      dispatcher.off(Constants.Navigations.TOGGLE_NAV, this.update)
    }

    toggleWithId(e) {
      customEvent(e)
      dispatcher.emit(Constants.Navigations.TOGGLE_NAV, this.eventData)
    }

    render() {
      return (
        <SubNavigationView id={this.props.id} toggleWithId={this.toggleWithId} {...this.props} />
      )
    }
  }

subnavigation.propTypes = {
  id: PropTypes.string.isRequired,
  dropdown: PropTypes.string
}

export default subnavigation



// WEBPACK FOOTER //
// ./assets/js/components/navigations/SubNavigation.jsx